module.exports = __webpack_public_path__ + "img/logo jeux active.745044be.png";